import {
  Box,
  DialogContent,
  IconButton,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import MuiAlert from "@material-ui/lab/Alert";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import * as Sentry from "@sentry/react";
import React, { useContext, useEffect, useState } from "react";
import { BsExclamationCircle } from "react-icons/bs";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import loaderGif from "../../assets/img/loader.gif";
import tds from "../../assets/icons/tds.svg";
import { CoinContext } from "../../contexts/CoinContext";
import { REACT_APP_PROD_URL } from "../../services/configs";
import fetcher from "../../api/swr_fetcher";
import { useDialog } from "../../contexts/DialogProvider";
import { isFirefox } from "react-device-detect";

import CloseIcon from "@material-ui/icons/Close";

function Alert(props) {
  return <MuiAlert variant="filled" elevation={6} {...props} />;
}

export default function BuySellCards(props) {
  const [openTransactionDialog, closeTransactionDialog] = useDialog();
  const darkMode = useSelector((state) => state.trading.DARK_MODE);
  const [openTDSDialog, setOpenTDSDialog] = useState(false);
  const [tdsStatus, setTdsStatus] = useState(false);
  const [statusChecked, setStatusCheck] = useState(false);
  const [refreshTDSStatus, setRefreshTDSStatus] = useState(false);

  const handleTransactionSuccess = (
    transactionCoin,
    transactionPrice,
    buyOrSell,
    transactionQuantity,
    transactionTDS,
    transactionINR,
    transactionRefund,
    transactionSaved
  ) => {
    openTransactionDialog({
      children: (
        <>
          <DialogTitle style={{ color: "#44CBB3", width: "350px" }}>
            <strong>{"Trade Successful"}</strong>
          </DialogTitle>
          <DialogContent
            style={{
              padding: "2px 24px 24px 24px",
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <div
              style={{
                width: "100%",
                paddingBottom: "10px",
                borderBottom: "1px solid rgba(96, 96, 96, 0.35)",
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div>Coin</div>
                <div>
                  {coin.config.coinName}({transactionCoin})
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div>Price</div>
                <div>&#8377;{transactionPrice}</div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                {buyOrSell === "buy" ? (
                  <div>{transactionCoin} Bought</div>
                ) : (
                  <div>{transactionCoin} Sold</div>
                )}
                <div>{transactionQuantity}</div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div>TDS</div>

                <div>- &#8377;{transactionTDS}</div>
              </div>
            </div>

            <div
              style={{
                width: "100%",
                marginLeft: "0",
                padding: "10px 0px",
                borderBottom: "1px solid rgba(96, 96, 96, 0.35)",
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                {buyOrSell === "buy" ? (
                  <div>Total INR Spent</div>
                ) : (
                  <div>Total INR Received</div>
                )}
                <div>&#8377;{transactionINR}</div>
              </div>
              {buyOrSell === "buy" ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div>Refunded to Wallet</div>
                  <div>
                    &#8377;{isNaN(transactionRefund) ? 0 : transactionRefund}
                  </div>
                </div>
              ) : null}
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginLeft: "0",
                padding: "10px 0px",
                borderBottom: "1px solid rgba(96, 96, 96, 0.35)",
              }}
            >
              <div style={{ color: "#44CBB3", fontSize: "20px" }}>
                <strong>&#8377;{transactionSaved}</strong>
              </div>
              <div>Fees saved*</div>
            </div>
            {/* <hr style={{ width: '100%', marginBottom: '10px' }} /> */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                marginLeft: "0",
                paddingTop: "10px",
              }}
            >
              <p style={{ fontSize: "10px", color: "#D9DADB" }}>
                *Based on average Indian exchange fees
              </p>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  closeTransactionDialog();
                  setTransactionSuccessfulDialog(false);
                  setTransactionCoin("BTC");
                  setTransactionINR(0);
                  setTransactionPrice(0);
                  setTransactionQuantity(0);
                  setTransactionTDS(0);
                  setTransactionSave(0);
                  setTransactionRefund(0);
                }}
                style={{ color: "white" }}
              >
                OK
              </Button>
            </div>
          </DialogContent>
        </>
      ),
    });
  };

  const classes = useStyles();
  const theme = useTheme();
  let history = useHistory();
  const token = useSelector((state) => state.trading.TOKEN);
  const { coin } = props;
  const prices = useSelector((state) => state.priceReducer.PRICES);
  console.log(coin, token, "tokenneame  ");
  const { updateOrders, refreshBalances, handleClickAlert } =
    useContext(CoinContext);

  const [tradeTypeBuy, setTradeTypeBuy] = useState("instant");
  const [tradeTypeSell, setTradeTypeSell] = useState("instant");
  const [openDialog, setDialog] = useState(false);
  const [inrBalance, setInrBalance] = useState(0);
  const [coinBalance, setCoinBalance] = useState({
    bal: 0,
    id: "",
  });

  const [doubleClickBuy, setDoubleClickBuy] = useState(false);
  const [doubleClickSell, setDoubleClickSell] = useState(false);
  const [loadingBal, setLoadingBal] = useState(false);
  const [whichDialog, setWhichDialog] = useState(null);
  const [orderDialog, setOrderDialog] = useState(false);

  const handleOrderDialogOpen = () => {
    setOrderDialog(true);
  };

  const handleOrderDialogClose = () => {
    setOrderDialog(false);
  };

  function getINRBalance() {
    fetcher(`/v1/balances/INR`)
      .then((data) => {
        if (data[0]) {
          setInrBalance(data[0].availableBalance);
        }
        // console.log("Getting inr balance:", data);
      })
      .catch((err) => {
        // console.error(err);
        console.error(err);
      });
  }

  function getCoinBalance() {
    setLoadingBal(true);
    var bearer = "Bearer " + token;
    var coinName = coin ? coin.symbol.slice(0, -3) : "BTC";
    fetcher(`/v1/balances/${coinName}`)
      .then((data) => {
        if (data[0]) {
          // setCoinBalance(data[0].availableBalance);
          setCoinBalance({
            bal: Number(data[0].availableBalance),
            id: data[0].coinId,
          });
          setLoadingBal(false);
        } else {
          // setCoinBalance(0);
          setCoinBalance({
            bal: 0,
            id: coinName,
          });
          setLoadingBal(false);
        }
        // console.log("Getting coin balance:", data);
      })
      .catch((err) => {
        // console.error(err);
        console.error(err);
      });
  }

  // getting balance
  useEffect(() => {
    if (token) {
      getINRBalance();
      getCoinBalance();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coin.symbol, refreshBalances]);

  // to handle conversion buy instant{
  const [buyInstQuant, setBuyInstQuant] = useState("");
  const [buyInstTP, setBuyInstTP] = useState("");
  const [disableBuy, setDisableBuy] = useState(null);
  // const [buyPrice, setBuyPrice] = useState(null)

  // const quantityInstBuy = (e) => {
  //   const n = +e.target.value || 0;
  //   setBuyInstQuant(n);
  //   if (prices) {
  //     if (prices[coin.symbol]) {
  //       setBuyInstTP(n * prices[coin.symbol]["a"]);
  //     }
  //   }
  // };

  // const tpInstBuy = (e) => {
  //   const n = +e.target.value || 0;
  //   setBuyInstTP(n);
  //   if (prices) {
  //     if (prices[coin.symbol]) {
  //       setBuyInstQuant(n / prices[coin.symbol]["a"]);
  //     }
  //   }
  // };

  const hanldeUpdateOrder = (data) => {
    return {
      type: "UPDATE_ORDER",
      payload: data,
    };
  };

  const [transactionCoin, setTransactionCoin] = useState("BTC");
  const [transactionPrice, setTransactionPrice] = useState(0);
  const [transactionQuantity, setTransactionQuantity] = useState(0);
  const [transactionTDS, setTransactionTDS] = useState(0);
  const [transactionINR, setTransactionINR] = useState(0);
  const [transactionSave, setTransactionSave] = useState(0);
  const [transactionRefund, setTransactionRefund] = useState(0);
  const [transactionType, setTransactionType] = useState("buy");

  function handleBuyInstant() {
    if (
      (Number(buyInstQuant) !== 0 && buyInstQuant !== "") ||
      (Number(buyInstTP) !== 0 && buyInstTP !== "")
    ) {
      // console.log(`User ${token}: Bought ${buyInstQuant} coins for ${buyInstTP} rupees.`)

      fetcher(`/v1/orders`, {
        method: "POST",
        body: {
          symbol: `${coin.symbol}`,
          quantity: `${buyInstQuant}`,
          side: "BUY",
          type: "MARKET",
          inrValue: `${buyInstTP}`,
        },
      })
        .then((data) => {
          console.log("BUY: ", data);
          if (data[0]) {
            if (data[0].status === "FAILED") {
              handleClickAlert(
                "error",
                `Failed to place the order: ${data[0].reason}`
              );
              if (data[0].reason.slice(0, 3) == 406) {
                props.openMissingDocsDialog();
              }
              getINRBalance();
              getCoinBalance();
            } else if (data[0].status === "PENDING") {
              handleClickAlert("success", "Successfully placed the order.");
              // ReduxStore.dispatch(hanldeUpdateOrder(data[0].orderId));
              updateOrders(data[0].orderId);
              getINRBalance();
              getCoinBalance();
            } else if (data[0].status === "FILLED") {
              setTransactionCoin(data[0].symbol.slice(0, -3));
              setTransactionPrice(data[0].pbRate);
              setTransactionQuantity(data[0].quantity);
              setTransactionTDS(data[0].tds);
              setTransactionINR(data[0].inrDebited);
              setTransactionSave(0.002 * data[0].inrDebited);
              setTransactionType("buy");
              if (buyInstTP != "") {
                setTransactionRefund(
                  (parseFloat(buyInstTP) - data[0].inrDebited).toFixed(2)
                );
              }
              handleTransactionSuccess(
                data[0].symbol.slice(0, -3),
                data[0].pbRate,
                "buy",
                data[0].quantity,
                data[0].tds,
                data[0].inrDebited,

                (parseFloat(buyInstTP) - data[0].inrDebited).toFixed(2),
                (0.002 * data[0].inrDebited).toFixed(2)
              );
              // handleClickAlert("success", "Successfully placed the order.");
              // ReduxStore.dispatch(hanldeUpdateOrder(data[0].orderId));
              updateOrders(data[0].orderId);
              getINRBalance();
              getCoinBalance();
            }
          } else {
            handleClickAlert("error", `Failed to place the order`);
          }
          // to prevent placing multiple orders on double clicks
          setBuyInstQuant("");
          setBuyInstTP("");
          setDoubleClickBuy(false);
        })
        .catch((err) => {
          // console.error(err);
          console.error(err);
        });
    } else {
      handleClickAlert("error", "Please enter the quantity or total INR");
      setDoubleClickBuy(false);
    }
  }
  // setDoubleClickBuy(false)

  useEffect(() => {
    setBuyInstQuant("");
    setBuyInstTP("");
  }, [coin.symbol]);
  // }to handle conversion buy instant

  // to handle conversion buy pro{
  const [buyProQuant, setBuyProQuant] = useState("");
  const [buyProPrice, setBuyProPrice] = useState("");
  const [buyProTP, setBuyProTP] = useState("");

  const quantityProBuy = (e) => {
    let val = ValidateQuantityDecimal(e);
    setBuyProQuant(val.replace(/[^0-9.]*/, ""));
    if (
      // Number(buyProPrice) !== 0 &&
      buyProPrice !== "" &&
      buyProPrice !== "Infinity" &&
      buyProPrice !== "NaN"
    ) {
      setBuyProTP((val * buyProPrice).toFixed(4));
    } else if (val === "Infinity" || val === "NaN") {
      setBuyProQuant("");
      setBuyProPrice("");
      setBuyProTP("");
    }
  };

  const priceProBuy = (e) => {
    let deci = coin.config ? coin.config.decimalTrade : 2;
    let val_1 = ValidateINRDecimal(e);
    setBuyProPrice(val_1);
    if (
      // Number(buyProQuant) !== 0 &&
      buyProQuant !== "" &&
      buyProQuant !== "Infinity" &&
      buyProQuant !== "NaN"
    ) {
      setBuyProTP((val_1 * buyProQuant).toFixed(4));
    } else if (
      // Number(buyProTP) !== 0 &&
      buyProTP !== "" &&
      buyProTP !== "Infinity" &&
      buyProTP !== "NaN" &&
      Number(val_1) !== 0
    ) {
      setBuyProQuant((buyProTP / val_1).toFixed(deci));
    } else if (val_1 === "Infinity" || val_1 === "NaN") {
      setBuyProQuant("");
      setBuyProPrice("");
      setBuyProTP("");
    }
  };

  const tpProBuy = (e) => {
    let deci = coin.config ? coin.config.decimalTrade : 2;
    let val_2 = ValidateINRDecimal(e);
    setBuyProTP(val_2);
    if (
      Number(buyProPrice) !== 0 &&
      buyProPrice !== "" &&
      buyProPrice !== "Infinity" &&
      buyProPrice !== "NaN"
      // && Number(val_2) !== 0
    ) {
      setBuyProQuant((val_2 / buyProPrice).toFixed(deci));
    } else if (val_2 === "Infinity" || val_2 === "NaN") {
      setBuyProQuant("");
      setBuyProPrice("");
      setBuyProTP("");
    }
  };

  function handleBuyPro() {
    if (
      Number(buyProQuant) !== 0 &&
      Number(buyProPrice) !== 0 &&
      buyProQuant !== "" &&
      buyProPrice !== "" &&
      buyProQuant !== "Infinity" &&
      buyProPrice !== "Infinity"
    ) {
      // console.log(`Bought ${buyProQuant} coins for ${buyProTP} rupees.`)
      fetcher(`/v1/orders`, {
        method: "POST",
        body: {
          symbol: `${coin.symbol}`,
          quantity: `${buyProQuant}`,
          side: "BUY",
          type: "LIMIT",
          price: `${buyProPrice}`,
          expirationTime: "365",
        },
      })
        .then((data) => {
          // console.log(data);
          if (data[0]) {
            if (data[0].status === "FAILED") {
              handleClickAlert(
                "error",
                `Failed to place the order: ${data[0].reason}`
              );
              if (data[0].reason.slice(0, 3) == 406) {
                props.openMissingDocsDialog();
              }
              getINRBalance();
              getCoinBalance();
            } else if (
              data[0].status === "FILLED" ||
              data[0].status === "PENDING"
            ) {
              handleClickAlert("success", "Successfully placed the order.");
              // ReduxStore.dispatch(hanldeUpdateOrder(data[0].orderId));
              updateOrders(data[0].orderId);
              getINRBalance();
              getCoinBalance();
            }
          } else {
            handleClickAlert("error", `Failed to place the order`);
          }
          // to prevent placing multiple orders on double clicks
          setBuyProQuant("");
          setBuyProPrice("");
          setBuyProTP("");
          setDoubleClickBuy(false);
        })
        .catch((err) => {
          // console.error(err);
          console.error(err);
        });
    } else {
      handleClickAlert("error", "Please enter all the fields");
      setDoubleClickBuy(false);
    }
  }

  useEffect(() => {
    setBuyProQuant("");
    setBuyProPrice("");
    setBuyProTP("");
  }, [coin.symbol]);
  // }to handle conversion buy pro

  // to handle conversion sell instant{
  const [sellInstQuant, setSellInstQuant] = useState("");
  const [sellInstTP, setSellInstTP] = useState("");
  const [disableSell, setDisableSell] = useState(null);
  // const [sellPrice, setSellPrice] = useState(null)

  // const quantityInstSell = (e) => {
  //   const n = +e.target.value || 0;
  //   setSellInstQuant(n);
  //   if (prices) {
  //     if (prices[coin.symbol]) {
  //       setSellInstTP(n * prices?.[coin.symbol]?.["b"]);
  //     }
  //   }
  // };

  // const tpInstSell = (e) => {
  //   const n = +e.target.value || 0;
  //   setSellInstTP(n);
  //   if (prices) {
  //     if (prices[coin.symbol]) {
  //       setSellInstQuant(n / prices?.[coin.symbol]?.["b"]);
  //     }
  //   }
  // };

  function handleSellInstant() {
    if (
      (Number(sellInstQuant) !== 0 && sellInstQuant !== "") ||
      (Number(sellInstTP) !== 0 && sellInstTP !== "")
    ) {
      // console.log(`Bought ${sellInstQuant} coins for ${sellInstTP} rupees.`)
      var bearer = "Bearer " + token;
      fetcher(`/v1/orders`, {
        method: "POST",
        body: {
          symbol: `${coin.symbol}`,
          quantity: `${sellInstQuant}`,
          side: "SELL",
          type: "MARKET",
          inrValue: `${sellInstTP}`,
        },
      })
        .then((data) => {
          console.log("SELL: ", data);
          if (data[0]) {
            if (data[0].status === "FAILED") {
              handleClickAlert(
                "error",
                `Failed to place the order: ${data[0].reason}`
              );
              if (data[0].reason.slice(0, 3) == 406) {
                props.openMissingDocsDialog();
              }
              getINRBalance();
              getCoinBalance();
            } else if (data[0].status === "PENDING") {
              handleClickAlert("success", "Successfully placed the order.");
              // ReduxStore.dispatch(hanldeUpdateOrder(data[0].orderId));
              updateOrders(data[0].orderId);
              getINRBalance();
              getCoinBalance();
            } else if (data[0].status === "FILLED") {
              setTransactionCoin(data[0].symbol.slice(0, -3));
              setTransactionPrice(data[0].pbRate);
              setTransactionQuantity(data[0].quantity);
              setTransactionTDS(data[0].tds);
              setTransactionINR(data[0].inrCredited);
              setTransactionSave(0.002 * data[0].inrCredited);
              setTransactionType("sell");
              if (sellInstTP != "") {
                setTransactionRefund(
                  (parseFloat(sellInstTP) - data[0].inrCredited).toFixed(2)
                );
              }
              handleTransactionSuccess(
                data[0].symbol.slice(0, -3),
                data[0].pbRate,
                "sell",
                data[0].quantity,
                data[0].tds,
                data[0].inrCredited,
                (parseFloat(sellInstTP) - data[0].inrCredited).toFixed(2),
                (0.002 * data[0].inrCredited).toFixed(2)
              );
              // handleTransactionSuccess();
              // ReduxStore.dispatch(hanldeUpdateOrder(data[0].orderId));
              updateOrders(data[0].orderId);
              getINRBalance();
              getCoinBalance();
            }
          } else {
            handleClickAlert("error", `Failed to place the order`);
          }
          // to avoid double click
          setSellInstQuant("");
          setSellInstTP("");
          setDoubleClickSell(false);
        })
        .catch((err) => {
          // console.error(err)
        });
    } else {
      handleClickAlert("error", "Please enter the quantity or total INR");
      setDoubleClickSell(false);
    }
  }

  useEffect(() => {
    setSellInstQuant("");
    setSellInstTP("");
  }, [coin.symbol]);
  // }to handle conversion sell instant

  // to handle conversion sell pro{
  const [sellProQuant, setSellProQuant] = useState("");
  const [sellProPrice, setSellProPrice] = useState("");
  const [sellProTP, setSellProTP] = useState("");

  const quantityProSell = (e) => {
    let val = ValidateQuantityDecimal(e);
    setSellProQuant(val);
    if (
      // Number(sellProPrice) !== 0 &&
      sellProPrice !== "" &&
      sellProPrice !== "Infinity" &&
      sellProPrice !== "NaN"
    ) {
      setSellProTP((val * sellProPrice).toFixed(4));
    } else if (val === "Infinity" || val === "NaN") {
      setSellProQuant("");
      setSellProPrice("");
      setSellProTP("");
    }
  };

  const priceProSell = (e) => {
    let deci = coin.config ? coin.config.decimalTrade : 2;
    let val_1 = ValidateINRDecimal(e);
    setSellProPrice(val_1);
    if (
      // Number(sellProQuant) !== 0 &&
      sellProQuant !== "" &&
      sellProQuant !== "Infinity" &&
      sellProQuant !== "NaN"
    ) {
      setSellProTP((val_1 * sellProQuant).toFixed(4));
    } else if (
      // Number(sellProTP) !== 0 &&
      sellProTP !== "" &&
      sellProTP !== "Infinity" &&
      sellProQuant !== "NaN" &&
      Number(val_1) !== 0
    ) {
      setSellProQuant((sellProTP / val_1).toFixed(deci));
    } else if (val_1 === "Infinity" || val_1 === "NaN") {
      setSellProQuant("");
      setSellProPrice("");
      setSellProTP("");
    }
  };

  const tpProSell = (e) => {
    let deci = coin.config ? coin.config.decimalTrade : 2;
    let val_2 = ValidateINRDecimal(e);
    setSellProTP(val_2);
    if (
      Number(sellProPrice) !== 0 &&
      sellProPrice !== "" &&
      sellProPrice !== "Infinity" &&
      sellProQuant !== "NaN"
      // && Number(val_2) !== 0
    ) {
      setSellProQuant((val_2 / sellProPrice).toFixed(deci));
    } else if (val_2 === "Infinity" || val_2 === "NaN") {
      setSellProQuant("");
      setSellProPrice("");
      setSellProTP("");
    }
  };

  function handleSellPro() {
    if (
      Number(sellProQuant) !== 0 &&
      Number(sellProPrice) !== 0 &&
      sellProQuant !== "" &&
      sellProPrice !== "" &&
      sellProQuant !== "Infinity" &&
      sellProPrice !== "Infinity"
    ) {
      // console.log(`Sold ${sellProQuant} coins for ${sellProTP} rupees.`)
      fetcher(`/v1/orders`, {
        method: "POST",
        body: {
          symbol: `${coin.symbol}`,
          quantity: `${sellProQuant}`,
          side: "SELL",
          type: "LIMIT",
          price: `${sellProPrice}`,
          expirationTime: "365",
        },
      })
        .then((data) => {
          // console.log(data);
          if (data[0]) {
            if (data[0].status === "FAILED") {
              handleClickAlert(
                "error",
                `Failed to place the order: ${data[0].reason}`
              );
              if (data[0].reason.slice(0, 3) == 406) {
                props.openMissingDocsDialog();
              }
              getINRBalance();
              getCoinBalance();
            } else if (
              data[0].status === "FILLED" ||
              data[0].status === "PENDING"
            ) {
              handleClickAlert("success", "Successfully placed the order.");
              // ReduxStore.dispatch(hanldeUpdateOrder(data[0].orderId));
              updateOrders(data[0].orderId);
              getINRBalance();
              getCoinBalance();
            }
          } else {
            handleClickAlert("error", `Failed to place the order`);
          }
          // to avoid double click
          setSellProQuant("");
          setSellProPrice("");
          setSellProTP("");
          setDoubleClickSell(false);
        })
        .catch((err) => {
          // console.error(err)
        });
    } else {
      handleClickAlert("error", "Please enter all the fields");
      setDoubleClickSell(false);
    }
  }

  useEffect(() => {
    setSellProQuant("");
    setSellProPrice("");
    setSellProTP("");
  }, [coin.symbol]);
  // }to handle conversion buy pro

  const handleTradeTypeBuy = (event, newTradeTypeBuy) => {
    if (newTradeTypeBuy !== null) {
      setTradeTypeBuy(newTradeTypeBuy);
    }
  };

  const handleTradeTypeSell = (event, newTradeTypeSell) => {
    if (newTradeTypeSell !== null) {
      setTradeTypeSell(newTradeTypeSell);
    }
  };

  const [transactionSuccessfulDialog, setTransactionSuccessfulDialog] =
    useState(false);

  const handleTransactionSuccesfulDialogOpen = () => {
    setTransactionSuccessfulDialog(true);
  };

  const handleTransactionSuccessfulDialogClose = () => {
    setTransactionSuccessfulDialog(false);
    setTransactionCoin("BTC");
    setTransactionINR(0);
    setTransactionPrice(0);
    setTransactionQuantity(0);
    setTransactionTDS(0);
    setTransactionSave(0);
    setTransactionRefund(0);
  };

  const handleDialogOpen = () => {
    setDialog(true);
  };

  const handleDialogClose = () => {
    setDialog(false);
  };

  function ValidateQuantityDecimal(e) {
    var beforeDecimal = 10;
    var afterDecimal = coin.config ? coin.config.decimalTrade : 2;
    let val = e.target.value
      .replace(/[^\d.]/g, "")
      .replace(new RegExp("(^[\\d]{" + beforeDecimal + "})[\\d]", "g"), "$1")
      .replace(/(\..*)\./g, "$1")
      .replace(new RegExp("(\\.[\\d]{" + afterDecimal + "}).", "g"), "$1");

    return val;
  }

  function ValidateINRDecimal(e) {
    var beforeDecimal = 8;
    var afterDecimal = coin.config ? coin.config.decimalInr : 2;
    let val = e.target.value
      .replace(/[^\d.]/g, "")
      .replace(new RegExp("(^[\\d]{" + beforeDecimal + "})[\\d]", "g"), "$1")
      .replace(/(\..*)\./g, "$1")
      .replace(new RegExp("(\\.[\\d]{" + afterDecimal + "}).", "g"), "$1");

    return val;
  }
  function toPlainString(num) {
    return ("" + +num).replace(
      /(-?)(\d*)\.?(\d*)e([+-]\d+)/,
      function (a, b, c, d, e) {
        return e < 0
          ? b + "0." + Array(1 - e - c.length).join(0) + c + d
          : b + c + d + Array(e - d.length + 1).join(0);
      }
    );
  }

  // This function prints the text above the buy/sell button that tells the user about the quantity and total cost of the transaction
  function getReadableText(value, type) {
    switch (type) {
      case "buy":
        {
          switch (value) {
            case 1:
              return (
                <p>
                  You will receive approximately
                  <>
                    <span className={classes.highlightTextBuy}>
                      {" "}
                      <strong>
                        {Boolean(buyInstTP)
                          ? (buyInstTP / prices?.[coin.symbol]?.["a"]).toFixed(
                              coin.config.decimalTrade
                            )
                          : 0}
                      </strong>
                    </span>{" "}
                    quantity of {coin.symbol.slice(0, -3)} at a total cost of{" "}
                    <span className={classes.highlightTextBuy}>
                      <strong>₹{Boolean(buyInstTP) ? buyInstTP : 0}</strong>
                    </span>{" "}
                  </>
                </p>
              );
            case 2:
              return (
                <p>
                  You will receive{" "}
                  <span className={classes.highlightTextBuy}>
                    {" "}
                    <strong>{buyInstQuant} </strong>
                  </span>
                  quantity of {coin.symbol.slice(0, -3)} at an approximate cost
                  of{" "}
                  <span className={classes.highlightTextBuy}>
                    <strong>
                      ₹
                      {(prices?.[coin.symbol]?.["a"] * buyInstQuant).toFixed(
                        coin.config.decimalInr
                      )}
                    </strong>
                  </span>{" "}
                </p>
              );
          }
        }
        break;
      case "sell":
        {
          switch (value) {
            case 1:
              return (
                <p>
                  You will sell{" "}
                  <span className={classes.highlightTextSell}>
                    {" "}
                    <strong>
                      {Boolean(sellInstTP)
                        ? (sellInstTP / prices?.[coin.symbol]?.["b"]).toFixed(
                            coin.config.decimalTrade
                          )
                        : 0}
                    </strong>
                  </span>{" "}
                  quantity of {coin.symbol.slice(0, -3)} and receive
                  approximately{" "}
                  <span className={classes.highlightTextSell}>
                    <strong>₹{Boolean(sellInstTP) ? sellInstTP : 0}</strong>
                  </span>{" "}
                  incl. TDS
                </p>
              );
            case 2:
              return (
                <p>
                  You will sell{" "}
                  <span className={classes.highlightTextSell}>
                    {" "}
                    <strong>{sellInstQuant} </strong>
                  </span>{" "}
                  quantity of {coin.symbol.slice(0, -3)} and receive
                  approximately{" "}
                  <span className={classes.highlightTextSell}>
                    <strong>
                      ₹
                      {(prices?.[coin.symbol]?.["b"] * sellInstQuant).toFixed(
                        coin.config.decimalInr
                      )}
                    </strong>
                  </span>{" "}
                  incl. TDS
                </p>
              );
          }
        }
        break;
    }
  }

  useEffect(() => {
    fetcher("/v1/tds/status")
      .then((res) => {
        if (res.userAgreed) {
          setTdsStatus(res.userAgreed);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [refreshTDSStatus]);

  function handleTDSSubmit() {
    fetcher("/v1/tds/agree", { method: "POST" })
      .then((res) => {
        if (res.status == 200) {
          setRefreshTDSStatus((prev) => !prev);
          setOpenTDSDialog(false);
          handleClickAlert("success", "TDS consent is submitted successfully ");
          setBuyProQuant("");
          setBuyProPrice("");
          setBuyProTP("");
          setBuyInstQuant("");
          setBuyInstTP("");
          setSellInstQuant("");
          setSellInstTP("");
          setSellProQuant("");
          setSellProPrice("");
          setSellProTP("");
        }
      })
      .catch((err) => console.log(err));
  }

  return (
    <>
      {coin.config.tradeStatus === "ACTIVE" ? null : (
        <div className={classes.notice}>
          <BsExclamationCircle style={{ fontSize: "16px", color: "#3AC4AB" }} />
          <p
            style={{
              color: "#3AC4AB",
              fontSize: "12px",
              fontWeight: "bold",
              marginLeft: "7px",
            }}
          >
            {coin.config.tradeStatus === "PAUSED"
              ? `Please Note: Trading for ${
                  coin.config?.coinName || ""
                } is temporarily on hold`
              : `Please Note: Trading for ${
                  coin.config?.coinName || ""
                } has been Disabled`}
          </p>
        </div>
      )}

      {prices ? (
        <Grid container justify="space-between">
          <Grid item className={classes.buyCard}>
            <div
              className={classes.cardview}
              style={{
                pointerEvents:
                  prices[coin.symbol] && coin.config.tradeStatus === "ACTIVE"
                    ? null
                    : "none",
                opacity:
                  prices[coin.symbol] && coin.config.tradeStatus === "ACTIVE"
                    ? null
                    : "0.6",
              }}
            >
              <Box
                style={{
                  width: "80%",
                  margin: "0 auto",
                  padding: "5px 0 5px 0", //20px 0 20px 0
                }}
                display="flex"
                justifyContent="space-around"
                alignItems="center"
                className="md:my-0 md:mx-auto  w-full px-3"
              >
                <p
                  style={{
                    paddingBottom: "10px",
                    fontWeight: "bold",
                    fontSize: "16px",
                    color: "#3AC4AB",
                  }}
                >
                  <span style={{ fontSize: "13px" }}>Buy </span>
                  {prices
                    ? prices[coin.symbol]
                      ? `₹${prices?.[coin.symbol]?.["a"]}`
                      : ""
                    : ""}
                </p>
                <div className={classes.root} />
                <AccountBalanceWalletIcon
                  style={{
                    paddingBottom: "10px",
                    fontSize: "30px",
                    color:
                      theme.palette.type === "dark" ? "#C0C1C5" : "#9A9A9A",
                  }}
                />
                <div className={classes.walletBalance}>
                  &#x20B9;{Number(inrBalance).toFixed(2)} Wallet Balance
                </div>
              </Box>
              <ToggleButtonGroup
                value={tradeTypeBuy}
                exclusive
                onChange={handleTradeTypeBuy}
                style={{ width: "100%", justifyContent: "center" }}
              >
                <ToggleButton
                  value="instant"
                  style={
                    tradeTypeBuy === "instant"
                      ? {
                          borderBottomColor: "#3AC4AB",
                          borderBottomWidth: "3px",
                          background:
                            theme.palette.type === "dark"
                              ? "#1a2826"
                              : "#f0fffd",
                          fontSize: "10px",
                          color: "#3AC4AB",
                          fontWeight: "bold",
                        }
                      : { fontSize: "10px" }
                  }
                >
                  Instant Trade
                </ToggleButton>
                <ToggleButton
                  value="pro"
                  style={
                    tradeTypeBuy === "pro"
                      ? {
                          borderBottomColor: "#3AC4AB",
                          borderBottomWidth: "3px",
                          background:
                            theme.palette.type === "dark"
                              ? "#1a2826"
                              : "#f0fffd",
                          fontSize: "10px",
                          color: "#3AC4AB",
                          fontWeight: "bold",
                          borderLeftColor:
                            theme.palette.type === "dark"
                              ? "#3a3a3a"
                              : "#DADADA",
                        }
                      : { fontSize: "10px" }
                  }
                >
                  Pro Trade
                </ToggleButton>
              </ToggleButtonGroup>
              {tradeTypeBuy === "instant" ? (
                <div
                  style={{
                    display: "block",
                    marginLeft: "auto",
                    marginRight: "auto",
                    width: "70%",
                  }}
                >
                  <div
                    style={{
                      opacity: disableBuy === 1 ? "0.4" : null,
                    }}
                  >
                    <Typography
                      variant="body1"
                      component="p"
                      className={classes.fieldLabel}
                      style={{ marginTop: "15px" }} //30px
                    >
                      Quantity
                    </Typography>
                    <StyledOutline
                      type="number"
                      style={{
                        marginBottom: "15px",
                      }}
                      notched={true}
                      className={classes.styledInput}
                      onChange={(e) => {
                        // let deci = coin.config ? coin.config.decimalTrade : 2;
                        // let regex = new RegExp("(\\d{0, 5}.\\d{" + deci + "})\\d+", "g");
                        // let val = e.target.value.replace(regex, "$1");
                        // setBuyInstQuant(val.replace(/[^0-9]*/, ""));
                        setBuyInstQuant(ValidateQuantityDecimal(e));
                        if (e.target.value) {
                          setDisableBuy(2);
                        } else {
                          setDisableBuy(null);
                        }
                      }}
                      onClick={() => {
                        if (disableBuy === 1) {
                          setDisableBuy(null);
                          setBuyInstQuant("");
                          setBuyInstTP("");
                        }
                      }}
                      value={buyInstQuant}
                      disabled={disableBuy === 1 ? true : false}
                      step="0.01"
                      placeholder={`Quantity of ${coin.symbol.slice(0, -3)}`}
                    />
                  </div>

                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <p className={classes.fieldLabel}>OR</p>
                  </div>

                  <div style={{ opacity: disableBuy === 2 ? "0.4" : null }}>
                    <span
                      className={classes.fieldLabel}
                      style={{ marginTop: "5px" }}
                    >
                      TOTAL INR
                    </span>
                    <StyledOutline
                      type="number"
                      className={classes.styledInput}
                      onChange={(e) => {
                        // let inrDeci = 4
                        // let regex = new RegExp("(\\.\\d{" + inrDeci + "})\\d+", "g");
                        // setBuyInstTP(e.target.value.replace(regex, "$1"));
                        setBuyInstTP(ValidateINRDecimal(e));
                        if (e.target.value) {
                          setDisableBuy(1);
                        } else {
                          setDisableBuy(null);
                        }
                      }}
                      onClick={() => {
                        if (disableBuy === 2) {
                          setDisableBuy(null);
                          setBuyInstQuant("");
                          setBuyInstTP("");
                        }
                      }}
                      value={buyInstTP}
                      disabled={disableBuy === 2 ? true : false}
                      step="0.01"
                      placeholder="Total INR to spend"
                    />
                  </div>
                  <br></br>
                  {/*(buyInstTP >= 800 || buyInstTP===0) ? null : <p style={{color: 'red', margin: 0}}>Price should be above 800rs</p>*/}
                  {(Boolean(buyInstTP) || Boolean(buyInstQuant)) &&
                    getReadableText(disableBuy, "buy")}
                  <Button
                    onClick={() => {
                      setDoubleClickBuy(true);
                      if (token) {
                        if (buyInstQuant) {
                          if (
                            prices?.[coin.symbol]?.["a"] * buyInstQuant <=
                            Number(inrBalance)
                          ) {
                            setWhichDialog("BuyInst");
                            if (tdsStatus) {
                              handleOrderDialogOpen();
                            } else {
                              setOpenTDSDialog(true);
                              setDoubleClickBuy(false);
                            }
                            // handleBuyInstant();
                          } else {
                            handleClickAlert(
                              "error",
                              "Insufficient INR balance"
                            );
                            setDoubleClickBuy(false);
                          }
                        } else if (buyInstTP) {
                          if (Number(buyInstTP) <= Number(inrBalance)) {
                            setWhichDialog("BuyInst");
                            if (tdsStatus) {
                              handleOrderDialogOpen();
                            } else {
                              setOpenTDSDialog(true);
                              setDoubleClickBuy(false);
                            }
                            // handleBuyInstant();
                          } else {
                            handleClickAlert(
                              "error",
                              "Insufficient INR balance"
                            );
                            setDoubleClickBuy(false);
                          }
                        } else {
                          handleClickAlert(
                            "error",
                            "Please enter the quantity or total INR"
                          );
                          setDoubleClickBuy(false);
                        }
                      } else {
                        handleDialogOpen();
                        setDoubleClickBuy(false);
                      }
                    }}
                    disabled={doubleClickBuy}
                    variant="contained"
                    color="primary"
                    style={{
                      width: "100%",
                      height: "34px",
                      color: "white",
                      fontWeight: "bold",
                      fontSize: "13px",
                      marginBottom: "25px",
                      marginTop: "10px", //25px
                      borderRadius: "21px",
                    }}
                  >
                    Buy
                  </Button>
                </div>
              ) : (
                <div
                  style={{
                    display: "block",
                    marginLeft: "auto",
                    marginRight: "auto",
                    width: "70%",
                  }}
                >
                  <Typography
                    variant="body1"
                    component="p"
                    className={classes.fieldLabel}
                    style={{ marginTop: "15px" }} //30px
                  >
                    Quantity
                  </Typography>
                  <StyledOutline
                    type="number"
                    style={{ marginBottom: "15px" }}
                    className={classes.styledInput}
                    onChange={quantityProBuy}
                    value={buyProQuant || ""}
                    step="0.01"
                    placeholder={`Quantity of ${coin.symbol.slice(0, -3)}`}
                  />

                  <Typography
                    variant="body1"
                    component="p"
                    className={classes.fieldLabel}
                    style={{ marginTop: "5px" }}
                  >
                    Price
                  </Typography>
                  <StyledOutline
                    type="number"
                    style={{ marginBottom: "15px" }}
                    className={classes.styledInput}
                    onChange={priceProBuy}
                    value={buyProPrice || ""}
                    step="0.01"
                    placeholder={`Price of ${coin.symbol.slice(0, -3)}`}
                  />

                  <span
                    className={classes.fieldLabel}
                    style={{ marginTop: "5px" }}
                  >
                    Total INR
                  </span>
                  <StyledOutline
                    type="number"
                    className={classes.styledInput}
                    onChange={tpProBuy}
                    value={buyProTP || ""}
                    step="0.01"
                    placeholder="Total INR to spend"
                  />
                  {/*(buyProTP >= 800 || buyProTP===0) ? null : <p style={{color: 'red', margin: 0}}>Price should be above 800rs</p>*/}

                  <Button
                    onClick={() => {
                      setDoubleClickBuy(true);
                      if (token) {
                        if (buyProTP) {
                          if (Number(buyProTP) <= Number(inrBalance)) {
                            if (tdsStatus) {
                              handleBuyPro();
                            } else {
                              setOpenTDSDialog(true);
                              setDoubleClickBuy(false);
                            }
                          } else {
                            handleClickAlert(
                              "error",
                              "Insufficient INR balance"
                            );
                            setDoubleClickBuy(false);
                          }
                        } else {
                          handleClickAlert(
                            "error",
                            "Please enters all the fields"
                          );
                          setDoubleClickBuy(false);
                        }
                      } else {
                        handleDialogOpen();
                        setDoubleClickBuy(false);
                      }
                    }}
                    disabled={doubleClickBuy}
                    variant="contained"
                    color="primary"
                    style={{
                      width: "100%",
                      height: "34px",
                      color: "white",
                      fontWeight: "bold",
                      fontSize: "13px",
                      marginBottom: "25px",
                      marginTop: "10px", //25px
                      borderRadius: "21px",
                    }}
                  >
                    Buy
                  </Button>
                </div>
              )}
            </div>
          </Grid>

          <Grid item className={classes.sellCard}>
            <div
              className={classes.cardview}
              style={{
                pointerEvents:
                  prices[coin.symbol] && coin.config.tradeStatus === "ACTIVE"
                    ? null
                    : "none",
                opacity:
                  prices[coin.symbol] && coin.config.tradeStatus === "ACTIVE"
                    ? null
                    : "0.6",
              }}
            >
              <Box
                style={{
                  width: "80%",
                  margin: "0 auto",
                  padding: "5px 0 5px 0", //20px 0 20px 0
                }}
                display="flex"
                justifyContent="space-around"
                alignItems="center"
                className="md:my-0 md:mx-auto w-full px-3"
              >
                <div
                  style={{
                    paddingBottom: "10px",
                    fontWeight: "bold",
                    fontSize: "16px",
                    color: "#DB747B",
                  }}
                >
                  <span style={{ fontSize: "13px" }}>Sell </span>
                  {prices
                    ? prices[coin.symbol]
                      ? `₹${prices?.[coin.symbol]?.["b"]}`
                      : ""
                    : ""}
                </div>
                <div className={classes.root} />
                <AccountBalanceWalletIcon
                  style={{
                    paddingBottom: "10px",
                    fontSize: "30px",
                    color:
                      theme.palette.type === "dark" ? "#C0C1C5" : "#9A9A9A",
                  }}
                />
                <div className={classes.walletBalance}>
                  {loadingBal
                    ? "Loading... "
                    : `${toPlainString(Number(coinBalance.bal))} ${
                        coinBalance.id
                      } `}
                  Wallet Balance
                </div>
              </Box>
              <ToggleButtonGroup
                value={tradeTypeSell}
                exclusive
                onChange={handleTradeTypeSell}
                style={{ width: "100%", justifyContent: "center" }}
              >
                <ToggleButton
                  value="instant"
                  style={
                    tradeTypeSell === "instant"
                      ? {
                          borderBottomColor: "#3AC4AB",
                          borderBottomWidth: "3px",
                          background:
                            theme.palette.type === "dark"
                              ? "#1a2826"
                              : "#f0fffd",
                          fontSize: "10px",
                          color: "#3AC4AB",
                          fontWeight: "bold",
                        }
                      : { fontSize: "10px" }
                  }
                >
                  Instant Trade
                </ToggleButton>
                <ToggleButton
                  value="pro"
                  style={
                    tradeTypeSell === "pro"
                      ? {
                          borderBottomColor: "#3AC4AB",
                          borderBottomWidth: "3px",
                          background:
                            theme.palette.type === "dark"
                              ? "#1a2826"
                              : "#f0fffd",
                          fontSize: "10px",
                          color: "#3AC4AB",
                          fontWeight: "bold",
                          borderLeftColor:
                            theme.palette.type === "dark"
                              ? "#3a3a3a"
                              : "#DADADA",
                        }
                      : { fontSize: "10px" }
                  }
                >
                  Pro Trade
                </ToggleButton>
              </ToggleButtonGroup>

              {tradeTypeSell === "instant" ? (
                <div
                  style={{
                    display: "block",
                    marginLeft: "auto",
                    marginRight: "auto",
                    width: "70%",
                  }}
                >
                  <div style={{ opacity: disableSell === 1 ? "0.4" : null }}>
                    <Typography
                      variant="body1"
                      component="p"
                      className={classes.fieldLabel}
                      style={{ marginTop: "15px" }} //30px
                    >
                      Quantity
                    </Typography>
                    <StyledOutline
                      type="number"
                      style={{ marginBottom: "15px" }}
                      className={classes.styledInput}
                      onChange={(e) => {
                        // let deci = coin.config ? coin.config.decimalTrade : 2;
                        // let regex = new RegExp("(\\.\\d{" + deci + "})\\d+", "g");
                        // let val = e.target.value.replace(regex, "$1");
                        // setSellInstQuant(val.replace(/[^0-9.]*/, ""));
                        setSellInstQuant(ValidateQuantityDecimal(e));
                        if (e.target.value) {
                          setDisableSell(2);
                        } else {
                          setDisableSell(null);
                        }
                      }}
                      onClick={() => {
                        if (disableSell === 1) {
                          setDisableSell(null);
                          setSellInstQuant("");
                          setSellInstTP("");
                        }
                      }}
                      value={sellInstQuant}
                      disabled={disableSell === 1 ? true : false}
                      step="0.01"
                      placeholder={`Quantity of ${coin.symbol.slice(0, -3)}`}
                    />
                  </div>

                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <p className={classes.fieldLabel}>OR</p>
                  </div>

                  <div
                    style={{
                      opacity: disableSell === 2 ? "0.4" : null,
                    }}
                  >
                    <span
                      className={classes.fieldLabel}
                      style={{ marginTop: "5px" }}
                    >
                      TOTAL INR
                    </span>
                    <StyledOutline
                      type="number"
                      className={classes.styledInput}
                      onChange={(e) => {
                        // let inrDeci = 4
                        // let regex = new RegExp("(\\.\\d{" + inrDeci + "})\\d+", "g");
                        // setSellInstTP(e.target.value.replace(regex, "$1"));
                        setSellInstTP(ValidateINRDecimal(e));
                        if (e.target.value) {
                          setDisableSell(1);
                        } else {
                          setDisableSell(null);
                        }
                      }}
                      onClick={() => {
                        if (disableSell === 2) {
                          setDisableSell(null);
                          setSellInstQuant("");
                          setSellInstTP("");
                        }
                      }}
                      value={sellInstTP}
                      disabled={disableSell === 2 ? true : false}
                      step="0.01"
                      placeholder="Total INR to receive"
                    />
                  </div>
                  <br></br>
                  {/*(sellInstTP >= 800 || sellInstTP===0) ? null : <p style={{color: 'red', margin: 0}}>Price should be above 800rs</p>*/}
                  {(Boolean(sellInstTP) || Boolean(sellInstQuant)) &&
                    getReadableText(disableSell, "sell")}
                  <ColorButton
                    onClick={() => {
                      setDoubleClickSell(true);
                      if (token) {
                        if (sellInstQuant) {
                          if (sellInstQuant <= coinBalance.bal) {
                            setWhichDialog("SellInst");
                            if (tdsStatus) {
                              handleOrderDialogOpen();
                            } else {
                              setOpenTDSDialog(true);
                              setDoubleClickSell(false);
                            }
                            // handleSellInstant();
                          } else {
                            handleClickAlert(
                              "error",
                              "Insufficient coin balance"
                            );
                            setDoubleClickSell(false);
                          }
                        } else if (sellInstTP) {
                          if (
                            sellInstTP <=
                            coinBalance.bal * prices?.[coin.symbol]?.["b"]
                          ) {
                            setWhichDialog("SellInst");
                            if (tdsStatus) {
                              handleOrderDialogOpen();
                            } else {
                              setOpenTDSDialog(true);
                              setDoubleClickSell(false);
                            }
                            // handleSellInstant();
                          } else {
                            handleClickAlert(
                              "error",
                              "Insufficient coin balance"
                            );
                            setDoubleClickSell(false);
                          }
                        } else {
                          handleClickAlert(
                            "error",
                            "Please enter the quantity or total INR"
                          );
                          setDoubleClickSell(false);
                        }
                      } else {
                        handleDialogOpen();
                        setDoubleClickSell(false);
                      }
                    }}
                    disabled={doubleClickSell}
                    variant="contained"
                  >
                    Sell
                  </ColorButton>
                </div>
              ) : (
                <div
                  style={{
                    display: "block",
                    marginLeft: "auto",
                    marginRight: "auto",
                    width: "70%",
                  }}
                >
                  <Typography
                    variant="body1"
                    component="p"
                    className={classes.fieldLabel}
                    style={{ marginTop: "15px" }} //30px
                  >
                    Quantity
                  </Typography>
                  <StyledOutline
                    type="number"
                    style={{ marginBottom: "15px" }}
                    className={classes.styledInput}
                    onChange={quantityProSell}
                    value={sellProQuant || ""}
                    step="0.01"
                    placeholder={`Quantity of ${coin.symbol.slice(0, -3)}`}
                  />

                  <Typography
                    variant="body1"
                    component="p"
                    className={classes.fieldLabel}
                    style={{ marginTop: "5px" }}
                  >
                    Price
                  </Typography>
                  <StyledOutline
                    type="number"
                    style={{ marginBottom: "15px" }}
                    className={classes.styledInput}
                    onChange={priceProSell}
                    value={sellProPrice || ""}
                    step="0.01"
                    placeholder={`Price of ${coin.symbol.slice(0, -3)}`}
                  />

                  <span
                    className={classes.fieldLabel}
                    style={{ marginTop: "5px" }}
                  >
                    Total INR
                  </span>
                  <StyledOutline
                    type="number"
                    className={classes.styledInput}
                    onChange={tpProSell}
                    value={sellProTP || ""}
                    step="0.01"
                    placeholder="Total INR to receive"
                  />
                  {/*(sellProTP >= 800 || sellProTP===0) ? null : <p style={{color: 'red', margin: 0}}>Price should be above 800rs</p>*/}

                  <ColorButton
                    onClick={() => {
                      setDoubleClickSell(true);
                      if (token) {
                        if (sellProQuant && sellProPrice) {
                          if (Number(sellProQuant) <= Number(coinBalance.bal)) {
                            if (tdsStatus) {
                              handleSellPro();
                            } else {
                              setOpenTDSDialog(true);
                              setDoubleClickSell(false);
                            }
                          } else {
                            handleClickAlert(
                              "error",
                              "Insufficient coin balance"
                            );
                            setDoubleClickSell(false);
                          }
                        } else {
                          handleClickAlert(
                            "error",
                            "Please enters all the fields"
                          );
                          setDoubleClickSell(false);
                        }
                      } else {
                        handleDialogOpen();
                        setDoubleClickSell(false);
                      }
                    }}
                    disabled={doubleClickSell}
                    variant="contained"
                  >
                    Sell
                  </ColorButton>
                </div>
              )}
            </div>
          </Grid>
        </Grid>
      ) : null}

      <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        style={{ minHeight: "500px" }}
      >
        <DialogTitle>{"Please Login or SignUp to continue"}</DialogTitle>
        <DialogActions style={{ paddingBottom: "30px", paddingRight: "20px" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              history.push(`/login`);
            }}
            style={{ color: "white" }}
          >
            Login
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              history.push(`/createacc`);
            }}
            color="primary"
            autoFocus
          >
            Create an Account
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={transactionSuccessfulDialog}
        onClose={handleTransactionSuccessfulDialogClose}
        style={{ minHeight: "500px" }}
        // className={classes.transactionSuccessfulDialogStyle}
        PaperProps={{
          style: {
            // backgroundColor: 'rgba(0,0,0,0)',
            // boxShadow: '7px 4px 11px rgba(18, 18, 18, 0.25)',
            // borderRadius: '16px',
            // backdropFilter: 'blur(25px)'
            backgroundColor: "rgba(255,255,255,0.1)",
            backdropFilter: "blur(20px)",
            borderRadius: "16px",
            boxShadow:
              "0px 11px 15px -7px rgb(0 0 0 / 20%), 0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%);",
          },
        }}
      >
        <DialogTitle style={{ color: "#44CBB3", width: "350px" }}>
          <strong>{"Trade Successful"}</strong>
        </DialogTitle>
        <DialogActions
          style={{
            padding: "2px 24px 24px 24px",
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <div
            style={{
              width: "100%",
              paddingBottom: "10px",
              borderBottom: "1px solid rgba(96, 96, 96, 0.35)",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>Coin</div>
              <div>
                {coin.config.coinName}({transactionCoin})
              </div>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>Price</div>
              <div>&#8377;{transactionPrice}</div>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              {transactionType === "buy" ? (
                <div>{transactionCoin} Bought</div>
              ) : (
                <div>{transactionCoin} Sold</div>
              )}
              <div>{transactionQuantity}</div>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>TDS</div>

              <div>{transactionTDS}</div>
            </div>
          </div>
          <div
            style={{
              width: "100%",
              marginLeft: "0",
              padding: "10px 0px",
              borderBottom: "1px solid rgba(96, 96, 96, 0.35)",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              {transactionType === "buy" ? (
                <div>Total INR Spent</div>
              ) : (
                <div>Total INR Received</div>
              )}
              <div>&#8377;{transactionINR}</div>
            </div>
            {transactionType === "buy" ? (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div>Refunded to Wallet</div>
                <div>&#8377;{transactionRefund}</div>
              </div>
            ) : null}
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginLeft: "0",
              padding: "10px 0px",
              borderBottom: "1px solid rgba(96, 96, 96, 0.35)",
            }}
          >
            <div style={{ color: "#44CBB3", fontSize: "20px" }}>
              <strong>&#8377;{transactionSave.toFixed(2)}</strong>
            </div>
            <div>Fees saved*</div>
          </div>
          {/* <hr style={{ width: '100%', marginBottom: '10px' }} /> */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              marginLeft: "0",
              paddingTop: "10px",
            }}
          >
            <p style={{ fontSize: "10px", color: "#D9DADB" }}>
              *Based on average Indian exchange fees
            </p>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                handleTransactionSuccessfulDialogClose();
              }}
              style={{ color: "white" }}
            >
              OK
            </Button>
          </div>
        </DialogActions>
      </Dialog>

      <Dialog
        open={orderDialog}
        // onClose={handleOrderDialogClose}
        style={{ minHeight: "500px" }}
      >
        <DialogTitle>
          {
            "Please note the prices and total INR may be different on Instant trade execution due to volatility, for exact price and amount to spend kindly use Pro Trade."
          }
        </DialogTitle>
        <DialogActions style={{ paddingBottom: "30px", paddingRight: "20px" }}>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              if (whichDialog === "BuyInst") {
                setDoubleClickBuy(false);
              } else if (whichDialog === "SellInst") {
                setDoubleClickSell(false);
              }
              handleOrderDialogClose();
            }}
            style={{ fontWeight: "bold" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              if (whichDialog === "BuyInst") {
                handleBuyInstant();
              } else if (whichDialog === "SellInst") {
                handleSellInstant();
              }
              handleOrderDialogClose();
            }}
            color="primary"
            style={{ fontWeight: "bold", color: "white" }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openTDSDialog}
        onClose={() => {
          setOpenTDSDialog(false);
        }}
        PaperProps={{
          style: {
            ...(!isFirefox && {
              background: darkMode
                ? "rgba(255, 255, 255, 0.1)"
                : "rgba(0, 0, 0, 0.3)",
              backdropFilter: darkMode ? "blur(20px)" : "blur(10px)",
              WebkitBackdropFilter: darkMode ? "blur(20px)" : "blur(10px)",
              borderRadius: "16px",
            }),
          },
        }}
      >
        <DialogTitle
          style={{ color: "#FFFFFF" }}
          className="pb-1 md:pb-2 relative "
        >
          <IconButton
            className="absolute right-2 top-1"
            aria-label="close"
            onClick={() => {
              setOpenTDSDialog(false);
            }}
          >
            <CloseIcon style={{ color: "#676879" }} />
          </IconButton>
        </DialogTitle>

        <DialogContent className="">
          <div>
            <div className="flex flex-col items-center gap-y-7 mt-2 md:mt-4 mb-7">
              <strong className="text-2xl md:text-3xl">TDS Consent</strong>
              <div className="w-[95px] md:w-[128px] h-[108px] md:h-[132px] relative mb-4 md:mb-0">
                <img src={tds} alt="tds" />
              </div>
            </div>
            <div>
              {" "}
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleTDSSubmit();
                }}
              >
                <FormGroup className="my-5">
                  <FormControlLabel
                    className="flex items-start"
                    control={
                      <Checkbox
                        name="first"
                        required
                        color="primary"
                        onChange={(e) => {
                          setStatusCheck(e.target.checked);
                        }}
                      />
                    }
                    label={
                      <p className="text-xs md:text-base text-[#D1D1D1] w-full md:w-[300px]">
                        I hereby authorize PocketBits to deduct TDS on my
                        cryptocurrency trades when applicable and pay the same
                        on my behalf to the Income Tax Department as mandated by
                        the Indian tax laws.
                      </p>
                    }
                  />
                </FormGroup>
                <a
                  target="_blank"
                  className="h-max"
                  href="https://pocketbits.in/blog/tds-on-crypto-in-india/"
                >
                  <p className="text-pb-primary-200 text-sm md:text-lg font-medium underline mb-4 mt-6">
                    Details on TDS applicability
                  </p>
                </a>
                <Button
                  disabled={!statusChecked}
                  type="submit"
                  variant="contained"
                  className="py-2  bg-pb-primary-200 disabled:opacity-50 text-xs md:text-base"
                  style={{
                    width: "100%",
                    color: "white",
                    fontWeight: "bold",
                    marginBottom: "15px",
                    borderRadius: "5px",
                  }}
                >
                  Authorize
                </Button>
              </form>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <Backdrop
        className={classes.backdrop}
        open={doubleClickBuy || doubleClickSell}
      >
        {/* <CircularProgress color="primary" /> */}
        <img src={loaderGif} alt="loading..." />
      </Backdrop>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  highlightTextBuy: {
    color: "#3AC4AB",
  },
  highlightTextSell: {
    color: "#E65661",
  },
  paper: {
    margin: 6,
    borderRadius: 0,
    background: "transparent",
  },
  ptitle: {
    margin: 0,
    color: "#A7A8AF",
  },
  walletBalance: {
    paddingBottom: "10px",
    color: theme.palette.type === "dark" ? "#C0C1C5" : "#9A9A9A",
    fontSize: "13px",
  },
  cardview: {
    borderRadius: "25px",
    // boxShadow: "0px 20px 30px -10px rgba(104, 142, 176, 0.15) !important",
    background: theme.palette.type === "dark" ? "#151827" : "white",
    height: "auto",
    // padding: theme.spacing(5),
    // display: 'flex',
    // alignItems: 'center',
    // textAlign: 'center',
    // justifyContent: 'center',
    // margin: 'auto',
    paddingTop: theme.spacing(2),
  },
  topbar: {
    backgroundColor: "#151827",
    height: "30px",
  },
  buyCard: {
    marginTop: "15px",
    [theme.breakpoints.up("md")]: {
      width: "49.2%",
      // marginRight: '30px',
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  sellCard: {
    marginTop: "15px",
    [theme.breakpoints.up("md")]: {
      width: "49.2%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  order: {
    [theme.breakpoints.up("md")]: {
      marginLeft: "15px",
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "15px",
    },
  },
  styledInput: {
    width: "100%",
    // marginBottom: '15px',
    // background: "transparent",
    // border: '5px solid red',
    "*:focus": {
      outline: "none",
      highlight: "none",
    },
    background: theme.palette.type === "dark" ? "#2C3039" : "#F7F7F7",
    borderRadius: "8px",
    fontSize: "14px",
  },
  fieldLabel: {
    fontWeight: "bold",
    color: theme.palette.text.primary,
    opacity: "0.5",
    textTransform: "uppercase",
    // paddingLeft: "13px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.8rem",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "12px",
    },
  },
  iconSize: {
    marginBottom: "10px",
    marginRight: "5px",
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  styledAlert: {
    "& .MuiAlert-icon": {
      fontSize: 50,
      fontWeight: "bold",
    },
    fontSize: 15,
    fontWeight: "bold",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  notice: {
    display: "flex",
    // alignItems: "center",
    border: `1px solid #3AC4AB`,
    backgroundColor: "rgba(86,195,164,0.1)",
    padding: "10px",
    // width: "80%",
    marginTop: "25px",
    marginBottom: "13px",
    // marginLeft: "auto",
    // marginRight: "auto",
    borderRadius: "8px",
  },
  transactionSuccessfulDialogStyle: {
    "& .MuiPaper-root": {
      backgroundColor: "rgba(0,0,0,0.6)",
    },
    "& > MuiDialog-container > .MuiPaper-root": {
      backgroundColor: "white",
    },
  },
}));

const ColorButton = withStyles((theme) => ({
  root: {
    color: "white",
    fontWeight: "bold",
    fontSize: "13px",
    width: "100%",
    height: "34px",
    backgroundColor: "#E65661",
    "&:hover": {
      backgroundColor: "#9b1722",
    },
    marginBottom: "25px",
    marginTop: "10px", //25px
    borderRadius: "21px",
  },
}))(Button);

const StyledOutline = withStyles({
  root: {
    "& $notchedOutline": {
      borderWidth: 0,
    },
    "&:hover $notchedOutline": {
      borderWidth: 0,
    },
    "&$focused $notchedOutline": {
      borderWidth: "1px",
      borderColor: "#3AC4AB",
    },
  },
  focused: {},
  notchedOutline: {},
})(OutlinedInput);
